import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";

export const resetUnreadMessageCounter = async (
  chatId: string,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.RESET_COUNTERS,
    method: "POST",
    params: {
      chat_id: chatId,
    },
  });
};
